import React from 'react';
import { SvgIcon } from './svg-icon';

export const Clock2 = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M11.9904 2C6.47115 2 2 6.48077 2 12C2 17.5192 6.47115 22 11.9904 22C17.5192 22 22 17.5192 22 12C22 6.48077 17.5192 2 11.9904 2ZM12 20C7.58173 20 4 16.4183 4 12C4 7.58173 7.58173 4 12 4C16.4183 4 20 7.58173 20 12C20 16.4183 16.4183 20 12 20Z" />
    <path d="M12.5001 7H11.0001V13L16.2501 16.149L17.0001 14.9183L12.5001 12.25V7Z" />
  </SvgIcon>
);
